import {MAP_URL} from "../../constants/urls";

export function fixGetManyReports(json) {
    return {
        data: json.map((resource) => ({
            ...resource,
            id: resource.objectId,
            reportId: resource.objectId,
        })),
    };
}

export function reportMapperListResponse(json, headers) {
    return {
        data: json.map((resource) => ({
            ...resource,
            id: resource.objectId,
            reportId: resource.objectId,
        })),
        total: headers.get("X-Total-Count") ? parseInt(headers.get("X-Total-Count").split("/").pop(), 10) : 1000,
    };
}

export function reportMapperGetOneResponse(json) {
    return {
        data: {...json.result, id: json.result.objectId, reportId: json.result.objectId,
            conversationUrl: json.result.conversationId && MAP_URL.conversationAdminPanel+json.result.conversationId+"/show",
            messageUrl: json.result.messageId && MAP_URL.messageAdminPanel+json.result.messageId+"/show"}
};
}